import React from 'react';
import styled from 'styled-components';

import Slider from '../../../Global/Slider';
import RichText from '../../../Global/RichText';

import LogoKuter from '../../../../Images/logos/logo_kuter_xx_2.svg';

import {
  SLIDER_IMAGES,
  INTRO_TEXT,
} from '../../../../utils/EN/SliderSection/index';

const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1440px',
};

const SliderInfo = styled.div`
  padding: 110px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  row-gap: 86px;

  @media (max-width: ${breakpoints.mobile}) {
    padding: 20px 0px;
    row-gap: 0px;
  }

  svg {
    transition: all 0.3s ease-out;

    @media (max-width: ${breakpoints.mobile}) {
      transform: scale(0.7);
    }

    &:hover {
      filter: drop-shadow(0px 0px 14px rgba(255, 255, 255, 1));
    }
  }

  p {
    width: auto;
    padding: 10px;
    text-align: center;

    @media (min-width: ${breakpoints.tablet}) {
      width: 634px;
    }

    @media (min-width: ${breakpoints.desktop}) {
      width: 634px;
    }
  }
`;

const SliderSection = () => {
  return (
    <>
      <div className="container">
        <SliderInfo>
          <LogoKuter />
          <RichText dataText={INTRO_TEXT} />
          <Slider slides={SLIDER_IMAGES} />
        </SliderInfo>
      </div>
    </>
  );
};

export default SliderSection;
